import { render, staticRenderFns } from "./ConfirmationFood.vue?vue&type=template&id=5dce3e95&scoped=true&"
import script from "./ConfirmationFood.vue?vue&type=script&lang=js&"
export * from "./ConfirmationFood.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationFood.vue?vue&type=style&index=0&id=5dce3e95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce3e95",
  null
  
)

export default component.exports